
  import {Component, Prop, Vue} from "vue-property-decorator";

  @Component export default class Modal extends Vue {
    @Prop({default: null}) header: string;
    @Prop({default: null}) body: string;
    @Prop({default: null}) footer: string;
  }
